import {IOtherHabits} from '../../models/record-other-habits';
import {Component, OnInit} from '@angular/core';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';
import {IUserRegisterHabits} from '../../interfaces/record';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {IDataUnregisteredPatient} from '../../interfaces/data-unregistered-patient.interface';
import {StorageService} from '../../services/storage/storage.service';

@Component({
  selector: 'app-user-register-habits',
  templateUrl: './user-register-habits.component.html',
  styleUrls: ['./user-register-habits.component.scss']
})
export class UserRegisterHabitsComponent implements OnInit {
  habits: IUserRegisterHabits = null;
  helperValidationField: HelperValidationField;
  frequencies: any[] = [];
  form: UntypedFormGroup;
  constructor(
    public alertService: MessageAlertService,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.initValues();
  }

  initValues(): void {
    this.frequencies = [
      {
        label: 'No lo acostumbro',
        value: 0
      },
      {
        label: '1 a 2 días a la semana',
        value: 1
      },
      {
        label: '3 a 4 días a la semana',
        value: 3
      },
      {
        label: '5 a 7 días a la semana',
        value: 5
      }
    ];
    const data: IDataUnregisteredPatient = this.storageService.getLocalItem('dataUnregisteredPatient');
    console.log('data unregistered', data);
    const otherHabits: IOtherHabits = {
      drinkAlcohol: false,
      cupAlcoholPerDay: 0,
      drinkCoffee: false,
      cupCoffeePerDay: 0,
      smoke: false,
      cigarettesPerDay: 0,
      drinkAlcoholFrequency: 0,
      drinkCoffeeFrequency: 0,
      smokeFrequency: 0,
      howOftenHaveFeltUnableToControlImportantThings: 0,
      howOftenHaveBeenConfidentAboutAbilityToHandlePersonalProblems: 0,
      howOftenHaveFeltThatThingsAreGoingWell: 0,
      howOftenHaveFeltThatDifficultiesArePilingUpSoMuchThatCanOvercomeThem: 0
      // stressLevel: StressLevelEnum.WITH_OUT_STRESS,
    };
    /* this.habits = cloneDeep({
      drinkAlcohol: data?.drink || null,
      smoke: data?.smoke || null,
      physicalActivityHours: data?.activityHours || null,
      sleepQualityHours: data?.sleepHour || null
    }); */
    this.setFormProperties(otherHabits);
  }

  public validate(): boolean {
    const valid = this.form.valid;
    if (!valid) {
      this.alertService.createMessage('error', 'Debes completar los datos para seguir');
    }
    return valid;
  }

  public getValue(): IOtherHabits {
    return this.form.getRawValue();
  }

  setFormProperties(otherHabits: IOtherHabits): void {
    this.form = new UntypedFormGroup({
      drinkAlcohol: new UntypedFormControl(otherHabits ? otherHabits.drinkAlcohol || false : false, []),
      drinkAlcoholFrequency: new UntypedFormControl(otherHabits ? otherHabits.drinkAlcoholFrequency || 0 : 0, []),
      cupAlcoholPerDay: new UntypedFormControl(otherHabits ? otherHabits.cupAlcoholPerDay || 0 : 0, []),
      drinkCoffee: new UntypedFormControl(otherHabits ? otherHabits.drinkCoffee || false : false, []),
      drinkCoffeeFrequency: new UntypedFormControl(otherHabits ? otherHabits.drinkCoffeeFrequency || 0 : 0, []),
      cupCoffeePerDay: new UntypedFormControl(otherHabits ? otherHabits.cupCoffeePerDay || 0 : 0, []),
      smoke: new UntypedFormControl(otherHabits ? otherHabits.smoke || false : false, []),
      smokeFrequency: new UntypedFormControl(otherHabits ? otherHabits.smokeFrequency || 0 : 0, []),
      cigarettesPerDay: new UntypedFormControl(otherHabits ? otherHabits.cigarettesPerDay || 0 : 0, []),
    });
  }

  onChangeDrinkAlcohol($event): void {
  }

  onChangeDrinkCoffee($event): void {
  }

  onChangeSmoke($event): void {
  }
}
